module.exports = __webpack_public_path__ + "img/pic3.3f5db138.png";